import { clsx } from "clsx/lite"
import type { ComponentProps } from "react"

import { MarketingAnchor } from "@/components/marketing/lib/anchor"

export function Link({
  href,
  className,
  ...props
}: {
  href: string
} & Omit<ComponentProps<"a">, "href">) {
  return (
    <MarketingAnchor
      href={href}
      className={clsx("inline-flex cursor-pointer items-center gap-2 text-sm/7 font-medium text-mauve-950 dark:text-white", className)}
      {...props}
    />
  )
}
